// Module
var code = `<template>
  <template replaceable part="button"></template>
</template>

`;
// Exports
export default code;